export default __webpack_public_path__ + "static/media/BANNER-FULL-MOBILE_Covid_01_Oral.c980cab1.png";